// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var SignupController = function ($rootScope, $scope, $routeParams, $location, Signup, gettextCatalog) {
    $scope.signup = new Signup();
    $scope.signup.language = $location.$$search.language || 'de';
    gettextCatalog.currentLanguage = $scope.signup.language;

    $scope.register = function () {
        if (!$rootScope.isValid($scope.form))
            return;

        $scope.signup.$save({}, function () {
            $location.path("/signupcomplete");
        });
    };

};
SignupController.$inject = ['$rootScope', '$scope', '$routeParams', '$location', 'Signup', 'gettextCatalog'];
